import { axios } from '@/services/axios';

export const updateLocation = (locationData) => {
    return axios.put('/trunklocation/', locationData);
};
